export default {
  path: '/software',
  name: 'QualcommSoftware',
  children: [
    {
      path: '',
      name: 'SoftwareIndex',
      component: () => import('@/projects/Qualcomm/outerPges/software'),
    },
    {
      path: '/software/detail/:detailId',
      name: 'SoftwareDetail',
      component: () => import('@/projects/Qualcomm/outerPges/softDetail')
    },
  ]
}
